
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsSalesmanGrid extends Serenity.EntityGrid<PsSalesmanRow, any> {
        protected getColumnsKey() { return PsSalesmanColumns.columnsKey; }
        protected getDialogType() { return PsSalesmanDialog; }
        protected getIdProperty() { return PsSalesmanRow.idProperty; }
        protected getInsertPermission() { return PsSalesmanRow.insertPermission; }
        protected getLocalTextPrefix() { return PsSalesmanRow.localTextPrefix; }
        protected getService() { return PsSalesmanService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
    }
}